import axios from 'axios';
import Cookies from 'js-cookie';
import { notification } from 'antd';
import responseActions from '../../redux/responseAction/actions';
import store from '../../redux/store';
const { dispatch } = store;

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const LOGIN_PAGE = process.env.REACT_APP_BASE_URL;

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '') {
    return client({
      method: 'GET',
      url: path,
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
    });
  }

  static delete(path = '', data = {}) {
    return client({
      method: 'DELETE',
      url: path,
      data: JSON.stringify(data),
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use(config => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie  
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = {
    ...headers,
    Authorization: `Bearer ${Cookies.get('dcare_access_token')}`,
  };
  dispatch(responseActions.apiCallBegin());
  return requestConfig;
});

client.interceptors.response.use(
  response => {
    dispatch(responseActions.cleanResponseStatus());
    return response;
  },
  error => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    const originalRequest = error.config;
    // console.log('interceptors.error:', error);
    if (response) {
      dispatch(responseActions.setResponseStatus('error', response));
      if (response.status === 401) {
        notification.error({
          message: 'La sesión ha caducado. Por favor cierra tu sesión actual e ingresa nuevamente',
        });        
        Cookies.remove('dcare_logedIn');
        Cookies.remove('dcare_access_token');
        Cookies.remove('dcare_user');
        setTimeout(() => {
          document.location.href = LOGIN_PAGE;
        }, 2000)

      }
      if (response.status === 500) {
        // do something here
        return originalRequest;
      } else {
        return originalRequest;
      }
    }
    dispatch(responseActions.cleanResponseStatus());
    return Promise.reject(error);
  },
);

export { DataService };
